export enum BodyModifierClass {
  WIZARD_ACTIONS_VISIBLE = 'wizard-actions-visible',
  BATCH_MENU_VISIBLE = 'batch-menu-visible',
  HIDE_FRESHWORKS_WIDGETS = 'hide-freshworks-widgets',
  PAGINATION_VISIBLE = 'pagination-visible'
}
